import { Space, TableColumnsType } from "antd"
import { TObjectsConfigurationsTable } from "types/drawer.type"
import { ICategoryDimensions } from "types/configuration.type"
import { Checkbox } from "components/ui/checkbox/Checkbox"
import { CategoriesHandlers } from "./CategoriesHandlers"
import { CategoriesUtils } from "./CategoriesUtils"
import { ButtonOptions } from "components/ui/buttons/ButtonOptions/ButtonOptions"
import { Dropdown } from "components/ui/dropdown/Dropdown"
import { InModelTrain } from "components/ui/InModelTrain/InModelTrain"
import { ObjectTypeTooltip } from "components/ui/ObjectTypeTooltip/ObjectTypeTooltip"
import { TooltipWithDimensions } from "components/ui/tooltipWithDimensions/TooltipWithDimensions"
import { useCurrentUserStore } from "store/user.store"
import { Spin } from "components/ui/spin/Spin"

type ActionColumn = {
	deletable: boolean
	modelNumbers: string[]
	objectName: string
	name: string
	categoryId: number
	deletionProtectionReason: string
	preDeleteMessage: string
	dimensions: ICategoryDimensions
}

export const CategoriesColumns = () => {
	const { includeInProcessingHandle, isCategoryProcessing } = CategoriesHandlers()
	const { getDropDownItems } = CategoriesUtils()
	const { currentUser } = useCurrentUserStore()

	const tableColumns: TableColumnsType<TObjectsConfigurationsTable> = [
		{
			title: "NAME",
			dataIndex: "name",
			key: "name",
			width: 150,
			render: (item) => <div data-testid="name">{item}</div>,
		},
		{
			title: "",
			dataIndex: "type",
			key: "type",
			width: 50,
			render: (type) => (
				<div data-testid="type">
					<ObjectTypeTooltip type={type} />
				</div>
			),
		},
		{
			title: "LABEL",
			dataIndex: "modelLabel",
			key: "modelLabel",
			width: 100,
			render: (item) => <div data-testid="label">{item}</div>,
		},
		{
			title: "MODEL NUMBERS",
			dataIndex: "modelNumbers",
			key: "modelNumbers",
			width: 200,
			render: (item) => (
				<div data-testid="model-numbers">
					<TooltipWithDimensions item={item} />
				</div>
			),
		},
		{
			title: "IN MODEL",
			dataIndex: "includedInLatestModelTrain",
			key: "includedInLatestModelTrain",
			width: 60,
			render: (item) => (
				<div data-testid="in-model-train">
					<InModelTrain inModelTrain={item} />
				</div>
			),
		},
		{
			title: "OBJ. COUNT",
			dataIndex: "objectCount",
			key: "objectCount",
			width: 60,
			render: (item) => <div data-testid="object-count">{item}</div>,
		},
		{
			title: "PROCESSING",
			dataIndex: "includedInProcessingResult",
			key: "includedInProcessingResult",
			width: 70,
			render: (item) =>
				item.includedInLatestModelTrain ? (
					isCategoryProcessing(item.categoryId) ? (
						<Spin size="small" />
					) : (
						<div data-testid="processing">
							<Checkbox
								checked={item.includedInProcessingResult}
								onChange={(e) => includeInProcessingHandle(e.target.checked, item.categoryId)}
								onClick={(e) => e.stopPropagation()}
							/>
						</div>
					)
				) : null,
		},
		...(currentUser?.role === "Super Admin"
			? [
					{
						title: "",
						dataIndex: "action",
						key: "action",
						width: 50,
						render: (item: ActionColumn) => (
							<div onClick={(e) => e.stopPropagation()} data-testid="action-dropdown">
								<Dropdown items={getDropDownItems(item)}>
									<Space>
										<ButtonOptions />
									</Space>
								</Dropdown>
							</div>
						),
					},
				]
			: []),
	]

	return tableColumns
}
